import { http } from '@/api/http'
import type { ListResponse } from '@/types/api'
import type { RequestOptions } from '../crud'

/** The procurement documents that keep a «История изменений». */
export type ProcurementHistoryKind = 'plan' | 'proforma' | 'batch' | 'transport' | 'movement'

/**
 * One history event. A Proforma stores one `snapshot` per version; Plans,
 * Batches and transport units store the document before and after the change.
 */
export type ProcurementHistoryEvent = {
  id: string
  actor_profile_id: string
  actor_name: string
  actor_role_name_en: string
  actor_role_name_ru: string
  actor_role_name_uz: string
  actor_role_name_cyr: string
  event_type: string
  version: number
  reason?: string
  snapshot?: Record<string, unknown> | null
  before_snapshot?: Record<string, unknown> | null
  after_snapshot?: Record<string, unknown> | null
  created_at: string
}

const paths: Record<ProcurementHistoryKind, string> = {
  plan: 'plans',
  proforma: 'proformas',
  batch: 'batches',
  transport: 'transport-units',
  movement: 'movements',
}

export const procurementHistoryService = {
  /** Every event, newest first (the API caps a page at 1000). */
  async list(kind: ProcurementHistoryKind, id: string, options?: RequestOptions) {
    const { data } = await http.get<ListResponse<ProcurementHistoryEvent>>(`/procurement/${paths[kind]}/${encodeURIComponent(id)}/history`, {
      params: { page: 1, limit: 1000 },
      ...options,
    })
    return data.items ?? []
  },
}
